import { MPCRowField } from "./rowField";
import { MPCColorsField } from "./colors-field";
import { MPCRowContainerModule } from "./rowContainer";
import { MPCToolTip } from "../../helpers/toolTip";
import { MPCDeviceDetectionHelper } from "../../helpers/deviceDetectionHelper";
import { MPCValuesSubRowModule } from "./valuesSubRow";
const MinusIcon = require("../../../images/icon_minus.svg") as string;

export module MPCValuesRowModule {
    import RowField = MPCRowField.RowField;
    import ColorsField = MPCColorsField.ColorsField;
    import ToolTip = MPCToolTip.ToolTip;
    import DeviceDetectionHelper = MPCDeviceDetectionHelper.DeviceDetectionHelper;
    import RowContainer = MPCRowContainerModule.RowContainer;
    import SubValuesRow = MPCValuesSubRowModule.SubValuesRow;

    export class ValuesRow {
        public htmlElementOrNull: HTMLElement;
        private toolTips: Array<ToolTip> = new Array();
        public rowFieldsArray: Array<RowField>;
        public subRowColumnHeaderArray: Array<RowField>;
        public rowFieldsGroupedBySubRowId: { [id: number]: Array<RowField> };
        private deviceDetectionHelper: DeviceDetectionHelper;
        private parentRowContainer: RowContainer;
        private heightIsSet: boolean;

        public resolveRowFields(valuesRow: HTMLElement, filledColumns: number, parentMainHeadlineRow: RowContainer, categoryName: string): void {
            this.htmlElementOrNull = valuesRow;
            this.deviceDetectionHelper = DeviceDetectionHelper.instance;
            this.parentRowContainer = parentMainHeadlineRow;

            const subValuesRowElement : HTMLElement = valuesRow.querySelector('.sub-filter');
            if (subValuesRowElement) {
                const subValuesRow: SubValuesRow = new SubValuesRow();
                subValuesRow.init(subValuesRowElement, this.parentRowContainer.mpcModalContainer);
            }

            const rowFields: NodeListOf<HTMLElement> = valuesRow.querySelectorAll('.row-field');
            const tmpRowFieldsArray: Array<HTMLElement> = Array.prototype.slice.call(rowFields);
            this.rowFieldsArray = this.collectRowFieldValues(tmpRowFieldsArray, categoryName, filledColumns);
        }

        private collectRowFieldValues(tmpRowFieldsArray: Array<HTMLElement>, categoryName: string, filledColumns: number): Array<RowField> {
            let rowField: RowField;
            let rowFieldsArray = new Array<RowField>();

            let columnIndex: number = 1;
            for (const tmpRowField of tmpRowFieldsArray) {

                // set no-values-field icon:
                const noValuesField: HTMLElement = tmpRowField.querySelector('.no-values-field');
                if (noValuesField) {
                    noValuesField.innerHTML = MinusIcon;
                }

                // add toolTip hover event handlers:
                const tooltipContainers: NodeListOf<HTMLElement> = tmpRowField.querySelectorAll('.tooltip-container');
                if (tooltipContainers.length) {
                    this.registerToolTipEvents(tooltipContainers);
                }

                rowField = new RowField();
                    rowField.rowFieldHtmlElement = tmpRowField;
                    rowField.fieldValue = tmpRowField.innerHTML;

                    this.checkCustomRowFieldValues(tmpRowField, categoryName, rowField);
                    rowFieldsArray.push(rowField);

                // The last quarter of the field array contains all fields for the last column
                if (filledColumns === 4 && columnIndex > tmpRowFieldsArray.length * 0.75) {
                    tmpRowField.classList.add('last-column');
                }

                columnIndex++;
            }

            return rowFieldsArray;
        }

        private checkCustomRowFieldValues(tmpRowField: HTMLElement, categoryName: string, rowField: RowField): void {
            // collect price values:
            if (tmpRowField.classList.contains('price')) {
                rowField.price = tmpRowField.innerHTML;
            }

            // collect color values:
            if (tmpRowField.classList.contains('colors')) {
                const colorField: ColorsField = new ColorsField();
                colorField.init(tmpRowField, categoryName);
                rowField.colors = colorField;
            }

            // collect textModules:
            if (tmpRowField.classList.contains('textModules')) {
                rowField.textModule = tmpRowField.innerHTML;
            }

            // image value container:
            if (tmpRowField.classList.contains('image-container')) {
                rowField.fieldValue = tmpRowField.innerHTML;
            }

            // collect gloves:
            if (tmpRowField.classList.contains('gloves')) {
                const glovesRating: HTMLElement = tmpRowField.querySelector('.gloves-rating');

                if (glovesRating) {
                    rowField.fieldValue = glovesRating.getAttribute('data-filtervalue');
                }
            }
        }

        private registerToolTipEvents(tooltipContainers: NodeListOf<HTMLElement>): void {
            tooltipContainers.forEach((tooltipContainer: HTMLElement) => {
                this.toolTips.push(new ToolTip(tooltipContainer, this.parentRowContainer.mpcModalContainer));
            });
        }

        public collapseExpandRow(collapseRow: boolean): void {
            if (this.htmlElementOrNull) {

                if(!this.deviceDetectionHelper.isMobileShop() && 
                    !this.heightIsSet && !this.htmlElementOrNull.classList.contains('prices')) {
                    this.measureValuesRowHeight();
                    setTimeout(() => { this.collapseExpand(true); }, 100);
                }
                else 
                    this.collapseExpand(collapseRow);
            }
        }

        private measureValuesRowHeight(): void {
            const rowHeight: number = this.htmlElementOrNull.clientHeight;

            if(rowHeight > 0) {
                this.htmlElementOrNull.style.height = rowHeight + "px";
                this.heightIsSet = true;
            }
        }

        private collapseExpand(collapseRow: boolean): void {
            if (collapseRow) 
                    this.htmlElementOrNull.classList.add('row-collapsed');
                else
                    this.htmlElementOrNull.classList.remove('row-collapsed');
        }

        private rowFieldsAreEqual(): boolean {
            if (this.htmlElementOrNull && this.htmlElementOrNull.classList.contains(MPCRowField.PermanentlyHidden))
            {
                return true;
            }

            let firstRowField: RowField;
            let allFieldsInRowAreEqual = true;
            for (const subRowField of this.rowFieldsArray) {
                if (firstRowField) {
                    let isEqual: boolean = true;
                    if (firstRowField.price) {
                        if (firstRowField.price != subRowField.price) {
                            isEqual = false;
                        }
                    }
                    if (isEqual && firstRowField.colors) {
                        if (firstRowField.colors.colorsContent() != subRowField.colors.colorsContent()) {
                            isEqual = false;
                        }
                    }
                    if (isEqual && firstRowField.textModule) {
                        if (firstRowField.textModule != subRowField.textModule) {
                            isEqual = false;
                        }
                    }
                    if (isEqual && firstRowField.fieldValue !== subRowField.fieldValue) {
                        isEqual = false;
                    }
                    if (!isEqual) {
                        allFieldsInRowAreEqual = false;
                        break;
                    }
                } else {
                    firstRowField = subRowField;
                    continue;
                }
            }

            return allFieldsInRowAreEqual;
        }

        public showOnlyDifferences(newState: boolean): boolean {
            if (newState) {
                let allRowsAreEqual = this.rowFieldsAreEqual()
                if (allRowsAreEqual) {
                    // hide row heading
                    if (this.htmlElementOrNull)
                        this.htmlElementOrNull.classList.add(MPCRowField.UserHidden);
                    for (const rowField of this.rowFieldsArray) {
                        rowField.rowFieldHtmlElement.classList.add(MPCRowField.UserHidden);
                    }
                }
                return allRowsAreEqual;
            } else {
                //show all
                if (this.htmlElementOrNull)
                    this.htmlElementOrNull.classList.remove(MPCRowField.UserHidden);
                for (const rowField of this.rowFieldsArray) {
                    rowField.rowFieldHtmlElement.classList.remove(MPCRowField.UserHidden);
                }
                return false;
            }
        }

        public hideRowsWhereAllValuesAreEmpty(): boolean {
            let allValuesAreEmpty: boolean = true;

            for (const field of this.rowFieldsArray) {
                if (!field.rowFieldHtmlElement.classList.contains('no-values')) {
                    allValuesAreEmpty = false;
                }
            }

            // hide all row fields if necessary:
            if (allValuesAreEmpty) {
                for (const field of this.rowFieldsArray) {

                    // dummy sub filter titles are undefined:
                    if (this.htmlElementOrNull)
                        this.htmlElementOrNull.classList.add(MPCRowField.PermanentlyHidden);

                    field.rowFieldHtmlElement.classList.add(MPCRowField.PermanentlyHidden);
                }
            }

            return allValuesAreEmpty;
        }
    }
}